import axios from './axios';
import moment from 'moment';

const KdsService = {
  getKitchenData: async (restaurant_id) => {
    try {
      const response = await axios.get(`/kitchen?order_type=&kitchen_priority=`)
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  updateOrderData: async (cart_item_id, id, data) => {
    try {
      const url = `/carts/cart-items/${cart_item_id}/pos`;
      const response = await axios.put(url, data);
      return response.data.data;
    } catch (e) {
      return e;
    }
  },
  // updateOurStory: async ( data) => {
  //   try {
  //     const response = await axios.post(`/restaurants/customization/our-story`, data);
  //     return response.data.data;
  //   } catch (e) {
  //     console.error(e);
  //   }
  // },
  getExpoData: async (restaurant_id,is_sent_to_kitchen= false) => {
    try {
      const response = await axios.get(`/kitchen-expo?is_sent_to_kitchen=${is_sent_to_kitchen}&order_type=&kitchen_priority=`)
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  bumpData: async (cart_item_id, id, data) => {
    try {
      const response = await axios.put(`/cart/cart-item/${cart_item_id}`, data);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  getAllKdsStations: async (restaurantId) => {
    try {
      const response = await axios.get(`/kds-stations`);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  updateCartItems: async (payload) => {
    try {
      const response = await axios.put(`/carts/cart-items`, payload);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  getOrders: async (page = 1) => {
    let url = `/orders?page=${page}&page_limit=10&start=${moment().format('yyyy-MM-DD')}&end=${moment().format('yyyy-MM-DD')}&order_status=FULFILLED`;
    try {
      const response = await axios.get(url);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
};

export default KdsService;